<sn-fab-button
  (click)="toggleCollapse()"
  [matTooltip]="collapsed ? ('common.show' | t) : ('common.hide' | t)"
  [matTooltipPosition]="'after'"
  *ngIf="canSeeSecondaryNavbar"
>
  <sn-icon size="sm" *ngIf="collapsed">keyboard_arrow_right</sn-icon>
  <sn-icon size="sm" *ngIf="!collapsed">keyboard_arrow_left</sn-icon>
</sn-fab-button>
